var map = {
	"./Abhiraj Gupta.jpg": 9641,
	"./Atik Nazir.jpg": 8586,
	"./Avinesh Goyal.jpg": 7371,
	"./GaurikaMahi.jpg": 2298,
	"./Harsh Raj.jpg": 1712,
	"./Piyush Kumar.jpg": 6401,
	"./Prince Kumar.jpg": 5416,
	"./Rishi Raj.jpg": 2083,
	"./Ujjawal Goyal.jpg": 2773
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2136;